
import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Solutions from './components/Solutions';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import CTA from './components/CTA';
import Footer from '../home/components/Footer';

const ZohoOnePage: React.FC = () => {
  useEffect(() => {
    // Update page title and meta description for Zoho One page
    document.title = 'Zoho One Business Suite | Integrated CRM & Business Apps by WOTECH';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Zoho One integrated business suite with CRM, project management, accounting, and collaboration tools. Complete business automation solutions from WOTECH.');
    }

    // Add structured data for Zoho One product page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Zoho One Business Suite",
      "description": "Integrated business applications suite including CRM, project management, accounting, and collaboration tools",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/zohoone`,
      "brand": {
        "@type": "Brand",
        "name": "Zoho"
      },
      "provider": {
        "@type": "Organization",
        "name": "WOTECH"
      },
      "category": "Business Software Suite",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Products",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Zoho One",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/zohoone`
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Solutions />
        <Testimonials />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default ZohoOnePage;
